import useAxios from 'hooks/useAxios';

/**
 * Builds a client filter object suitable for the API.
 * Dates are expected to already be ISO 8601 strings.
 * Currency is expected to already be an uppercase string.
 *
 * @param {{ id: string, startDate?: string | null, endDate?: string | null, currency?: string | null }} filter
 * @returns {{ id: string, startDate?: string, endDate?: string, currency?: string }}
 */
const serializeClientFilter = (filter) => {
  const serialized = { id: filter.id };

  if (filter.startDate) {
    serialized.startDate = filter.startDate;
  }
  if (filter.endDate) {
    serialized.endDate = filter.endDate;
  }
  if (filter.currency) {
    serialized.currency = filter.currency;
  }

  return serialized;
};

/**
 * Fetch financial report data for the given per-client filters.
 *
 * @param {Array<{ id: string, startDate?: string | null, endDate?: string | null, currency?: string | null }>} filters
 */
export const getFinancialReport = (filters) => {
  const serializedFilters = filters.map(serializeClientFilter);

  const api = useAxios();
  return api.post('/metric/financial-report', {
    clients: serializedFilters
  });
};

/**
 * Export financial report to XLSX for a single client or all clients.
 *
 * @param {{ id?: string, startDate?: string | null, endDate?: string | null, currency?: string | null }} filter
 */
export const exportFinancialReport = (filter) => {
  const data = {};

  if (filter.id) {
    data.id = filter.id;
  }
  if (filter.startDate) {
    data.startDate = filter.startDate;
  }
  if (filter.endDate) {
    data.endDate = filter.endDate;
  }
  if (filter.currency) {
    data.currency = filter.currency;
  }

  const api = useAxios();
  return api.post('/metric/export/financial-report', data, {
    responseType: 'blob'
  });
};
